module.exports = __webpack_public_path__ + "assets/img/img-oneclick-problem-01@2x.8c1d5ab.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/oneclick/img-oneclick-problem-01@2x.png
// module id = 917
// module chunks = 1